import React from "react";
import PercentageChange from "./PercentageChange";
import StyledValue from "./StyledValue";
import {isMonetaryKpi, isUnsignedKpi} from "./PerformanceValue";

const scale = (number) => {
    if (Math.abs(number) >= 1e9) {
        return {suffix: "B", value: number / 1e9};
    }
    if (Math.abs(number) >= 1e6) {
        return {suffix: "M", value: number / 1e6};
    }
    if (Math.abs(number) >= 1e3) {
        return {suffix: "K", value: number / 1e3};
    }
    if (Math.abs(number) < 1e-3) {
        return {suffix: "", value: 0};
    }
    return {suffix: "", value: number};
};

const stripTrailingZero = (n) => {
    if (!n.includes(".")) {
        return n;
    }
    const c = n.substr(-1);
    return (c === "0" || c === ".") ? stripTrailingZero(n.slice(0, -1)) : n;
};

const format = (number) => {
    const scaled = scale(number);
    const plusPrefix = scaled.value > 0 ? "+" : "";
    return plusPrefix + stripTrailingZero(Number(scaled.value).toPrecision(3).toLocaleString()) + scaled.suffix;
};

export function scaledValue(value) {
    const scaled = scale(value);
    return stripTrailingZero(Number(scaled.value).toPrecision(3).toLocaleString()) + scaled.suffix;
}

function getPerformanceValue(kpi, value, display, className) {
    if (value === null) {
        return <div className={className}>&mdash;</div>
    }

    const perf = isMonetaryKpi(kpi) ?
                 <StyledValue value={value}>{display}</StyledValue> :
                 <PercentageChange change={value} isFraction={true} noLeadingPlus={isUnsignedKpi(kpi)}/>;

    return <div className={className}>{perf}</div>
}

export const SlimPerformanceValue = ({kpi, value, className}) => {
    const display = format(value);
    return getPerformanceValue(kpi, value, display, className);
};

export default ({kpi, value, currency}) => {
    const display = `${format(value)} ${currency}`;
    return getPerformanceValue(kpi, value, display);
};